import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-logo-submitter',
})
export class SignetLogoSubmitter {
  /**
   * Destination of the Logo
   */
  @Prop() href =  "http://submitter.episource.com";
  
  /**
   * SRC of the logo (Optional)
   */
  @Prop() src =  'https://design.episource.com/img/logo/Product=Submitter.svg';

  /**
   * Alternative Text
   */
    @Prop() alt =  'EpiSubmitter Logo';

  private getLogoLink(): string {
    return ( this.href );
  }

  private getImageLink(): string {
    return ( this.src );
  }


  private getAltText(): string {
    return ( this.alt );
  }

  render() {
    return (
      <a class='signet-logo-submitter signet-product-icon' href={this.getLogoLink()}><img src={this.getImageLink()} alt={this.getAltText()} /></a>
    );
  }
}
